exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-dim {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1100; }\n  .modal-dim .modal {\n    width: 30em;\n    background: white;\n    margin: 5em auto;\n    padding: 1em 2em 2em;\n    overflow: hidden; }\n    .modal-dim .modal .info, .modal-dim .modal .question {\n      font-size: 1.2em; }\n    .modal-dim .modal .button {\n      margin: 1em auto 0;\n      display: block;\n      clear: both;\n      overflow: hidden; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/ModalComponent/modal.component.scss
// module id = ./src/app/common/components/ModalComponent/modal.component.scss
// module chunks = main